{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "olenka/badge",
	"version": "1.0.0",
	"title": "Badge",
	"category": "olenka-general",
	"icon": "tag",
	"description": "Add Badge",
	"supports": {
		"html": false,
		"align": [
			"left",
			"right",
			"full",
			"center"
		],
		"color": {
			"background": true,
			"text": true
		}
	},
	"attributes": {
		"align": {
			"type": "string",
			"default": ""
		},
		"text": {
			"type": "string",
			"default": "Hello World!"
		},
		"blockBackgroundColor": {
			"type": "string",
			"default": "#ffffff"
		},
		"squareBackgroundColor": {
			"type": "string",
			"default": "#90d092"
		},
		"textColor": {
			"type": "string",
			"default": "#000000"
		}
	},
	"textdomain": "olenka"
}